/**
 * Application route paths
 */
export const PATHS = {
  signIn: '/',
  dashboard: '/dashboard',
  openingHours: '/oeffnungszeitenverwaltung',
  staff: '/personalverwaltung',
} as const;
